import React, {useCallback, useEffect} from 'react';
import {getBetBy} from '../home/home.service';
import {getUrlParams, goTo} from '@/utils';

import {CommonActions, useNavigation, useRoute} from '@react-navigation/native';
import {homePage, homeScreen} from '@/config';
import globalStore from '@/services/global.state';
import {useFocusEffect, useNavigationState} from '@react-navigation/native';
import {useBetByInit} from '@/utils/betby';
const BetByContainer = () => {
  const navigation = useNavigation();
  const state = useNavigationState(_state => _state);
  const route = useRoute<any>();
  const inTab = !!route.params?.inTab;

  const toggle = useCallback((show = false) => {
    const container = document.getElementById('betby-container');
    if (container) {
      container.style.display = show ? 'flex' : 'none';
    }
  }, []);

  useFocusEffect(
    useCallback(() => {
      if (inTab) {
        return;
      }
      const status = localStorage.getItem('betbyRouteStatus');
      if (status && state.routes.length <= 1) {
        try {
          const _status = JSON.parse(status);
          const _route = _status.routes.find((r: any) => r.name === 'BetBy');
          if (_route) {
            const params = getUrlParams();
            _route.params = params;
            _status.stale = false;
            navigation.dispatch(CommonActions.reset(_status));
            // navigationRef.dispatch(CommonActions.reset(_status));
          } else {
            localStorage.removeItem('betbyRouteStatus');
          }
        } catch (e) {
          localStorage.removeItem('betbyRouteStatus');
        }
      } else {
        if (state) {
          localStorage.setItem('betbyRouteStatus', JSON.stringify(state));
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  const handleInitBetby = useCallback(() => {
    getBetBy().then(res => {
      const {brandId, token} = res;
      (window as any).platformBetby = new BTRenderer().initialize({
        brand_id: brandId,
        token: token,
        onTokenExpired() {
          // goTo('Login', {backPage: homePage});
          return new Promise(resolved => {
            getBetBy().then(info => resolved(info.token));
          });
          // goTo(homePage);
          // localStorage.removeItem('betbyRouteStatus');
        },
        themeName: 'default',
        lang: globalStore.lang ? globalStore.lang.split('_')[0] : 'en',
        target: document.getElementById('betby'),
        betSlipOffsetTop: 52,
        betSlipOffsetBottom: 80,
        stickyTop: 0,
        betslipZIndex: 999,
        onSessionRefresh() {
          goTo(homePage, {screen: homeScreen});
          !inTab && localStorage.removeItem('betbyRouteStatus');
        },
        onLogin() {
          goTo('Login', {backPage: homePage, sucessPage: homePage});
          !inTab && localStorage.removeItem('betbyRouteStatus');
        },
        onRegister() {
          goTo('Login', {backPage: homePage, sucessPage: homePage});
          !inTab && localStorage.removeItem('betbyRouteStatus');
        },
        onRecharge() {
          goTo('Recharge');
          !inTab && localStorage.removeItem('betbyRouteStatus');
        },
      });
    });
  }, [inTab]);

  useEffect(() => {
    if (route.params?.['bt-path'] && (window as any).platformBetby) {
      (window as any).platformBetby.updateOptions({
        url: route.params['bt-path'],
      });
    }
  }, [route.params]);

  const {token} = useBetByInit(() => {
    if (!(window as any).platformBetby) {
      handleInitBetby();
    }
  });

  useEffect(() => {
    const sub = globalStore.betbyBackSubject.subscribe(code => {
      if (code === 'back') {
        handleBack();
      }
    });

    return () => {
      sub.unsubscribe();

      setTimeout(() => {
        console.log(inTab, window.location.pathname);
        if (
          (window as any).platformBetby &&
          ((!inTab && !window.location.pathname.includes('BetBy')) ||
            (inTab && !window.location.pathname.includes('index/betby')))
        ) {
          (window as any).platformBetby.kill();
          (window as any).platformBetby = undefined;
        }
      }, 100);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useFocusEffect(
    useCallback(() => {
      toggle(true);
      return () => {
        setTimeout(() => {
          if (
            (!inTab && !window.location.pathname.includes('BetBy')) ||
            (inTab && !window.location.pathname.includes('index/betby'))
          ) {
            toggle(false);
          }
        }, 100);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  useEffect(() => {
    globalStore.updateAmount.next({});
    let intv: NodeJS.Timeout | null = setInterval(() => {
      globalStore.updateAmount.next({});
    }, 20000);
    return () => {
      if (intv != null) {
        clearInterval(intv);
        intv = null;
      }
    };
  }, []);

  const handleBack = useCallback(() => {
    localStorage.removeItem('betbyRouteStatus');
    window.history.back();
  }, []);
  return <></>;
};

export default BetByContainer;
